import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import { PlanBTList } from "../../../features/planBT/components/PlanBT/PlanBTList";
import styles from "./PlanListBTPage.module.scss";

export default function PlanListBTPage() {
  return (
    <div className={styles["page-container"]}>
      <HeaderTitleContent>Plan BT</HeaderTitleContent>
      <div className={styles["header-page"]}>
        <PlanBTList.AddButton />
        <div className={styles["header-page__search"]}>
          <PlanBTList.InputSearch />
        </div>
      </div>
      <PlanBTList.List />
    </div>
  );
}
